import React from "react";
import { Row, Col, Card, CardHeader, CardBody, Button } from "reactstrap";

const ProductView = ({ product, closeModal }) => {
  return (
    <Row>
      <Col xl="12">
        <Card className="bg-secondary shadow">
          <CardHeader className="bg-white border-0">
            <Row className="align-items-center">
              <Col xs="8">
                <h3 className="mb-0">View Product</h3>
              </Col>
              <Col className="text-right" xs="4">
                <Button
                  color="primary"
                  onClick={closeModal}
                  size="sm"
                  close
                  style={{ cursor: "pointer", fontSize: "25px" }}
                />
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <Row>
              <Col md="12">
                <p>
                  <strong>Product Name:</strong> {product?.productName}
                </p>
                <p>
                  <strong>Category:</strong> {product?.categoryName} ({product?.categoryCode})
                </p>
                <p>
                  <strong>Trade Unit:</strong> {product?.tradeUnit}
                </p>
                <p>
                  <strong>GST Eligible:</strong> {product?.gstEligible ? "Yes" : "No"}
                </p>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default ProductView;
